import { Flex, Header, Icon, PageLayout } from "@repo/ping-design";
import "./PingAppsHomePage.scss";
import PingVisionButton from "./PingVisionButton";
import PingMapsButton from "./PingMapsButton";
import PingDefaultButton from "./PingDefaultButton";
import { MeApiResponse,
  PERMISSIONS,} from "../../ts-types/apiTypes";

import { PLUGIN_URL, SAL_URL, PORTAL_URL } from "./Constants";
import AccountDropdown, { type AccountOption } from "./AccountDropdown";
import { useLogoutFunction } from "@propelauth/react";
import { useMemo } from "react";
import { constructHeaderName } from "../../utils/formatters";

const PingAppsHomePage = ({ me }: { me?: MeApiResponse }) => {
  const logout = useLogoutFunction();

  const name = useMemo(
    () => constructHeaderName(me?.first_name, me?.email),
    [me?.first_name, me?.email],
  );

  const permissions = me?.permissions ?? [];

  const accountOptions: AccountOption[] = [
    {
      id: "logout",
      label: (
        <Flex gap="2" align="center" style={{ width: "100%" }}>
          <Icon iconName="LogOut" size={16} />
          <div>Logout</div>
        </Flex>
      ),
      value: "logout",
      onClick: () => {
        logout(false);
      },
    },
  ];

  const canAccessVision = permissions.includes(PERMISSIONS.CanAccessPingVision);
  const canAccessLocation = permissions.includes(PERMISSIONS.CanAccessPingLocation);
  const canAccessSAL = permissions.includes(PERMISSIONS.CanAccessPingActivityLog);
  const canAccessSubmissionPortal = permissions.includes(PERMISSIONS.CanAccessPingSubmissionPortal);
  const canAccessChromeExtension = permissions.includes(PERMISSIONS.CanAccessPingLocationExtension);

  return (
    <PageLayout title="Ping.Apps" className="PingAppsHomePage">
      <Header fullWidth className="PingAppsHomePage__Header">
        <Flex direction="row" justify="end" align="center">
          <AccountDropdown name={name} account_options={accountOptions} />
        </Flex>
      </Header>
      <Flex
        className="PingAppsHomePage__Content"
        direction="column"
        align="center"
        justify="center"
        gap="10"
      >
        <Flex
          className="PingAppsHomePage__Content__UpperRow"
          gap="10"
          align="center"
        >
          <PingVisionButton disabled={!canAccessVision} />
          <PingMapsButton disabled={!canAccessLocation} />
        </Flex>
        <Flex className="PingAppsHomePage__Content__LowerRow" gap="10">
          <PingDefaultButton
            iconName="Rows3"
            label={["Submission Activity Log"]}
            url={SAL_URL}
            disabled={!canAccessSAL}
          />

          <PingDefaultButton
            iconName="CloudUpload"
            label={["Submission Portal"]}
            url={PORTAL_URL}
            disabled={!canAccessSubmissionPortal}
          />
          <PingDefaultButton
            iconName="MapPinned"
            label={["PING.Location", "Chrome Extension"]}
            url={PLUGIN_URL}
            disabled={!canAccessChromeExtension}
          />
        </Flex>
      </Flex>
    </PageLayout>
  );
};

export default PingAppsHomePage;
